<template>
  <b-card no-body>
    <!-- Card header -->
    <b-card-header>
      <!-- Title -->
      <b-row align-v="center">
        <b-col cols="7" lg="6">
          <h5 class="h3 mb-0">Minhas notificações</h5>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-button
            @click="handleClickButtonNewMessage"
            size="sm"
            type="neutral"
            >{{ newMessageButtonText }}</base-button
          >
        </b-col>
      </b-row>
    </b-card-header>
    <!-- Card body -->
    <b-card-body class="b-card-body">
      <div v-show="showForm">
        <form-messages
          ref="formMessage"
          :formDisableButton="formDisableButton"
          :formButtonText="formButtonText"
          @submit="submitForm"
        ></form-messages>
      </div>

      <div
        v-show="!showForm"
        class="timeline timeline-one-side"
        data-timeline-content="axis"
      >
        <div class="pt-4 text-center" v-if="loadingMessages">
          Carregando mensagens ...
        </div>
        <div v-else>
          <div class="pt-4 text-center" v-if="!messages.length">
            Nenhuma mensagem encontrada
          </div>
          <div
            v-for="message in messages"
            :key="message.id"
            class="timeline-block"
          >
            <base-button
              v-if="message.from == user.id"
              round
              type="primary"
              class="btn-icon-only"
            >
              <span class="btn-inner--icon"
                ><i class="fas fa-arrow-down"></i
              ></span>
            </base-button>
            <base-button v-else round type="success" class="btn-icon-only">
              <span class="btn-inner--icon"
                ><i class="fas fa-arrow-up"></i
              ></span>
            </base-button>

            <div class="text-right">
              <small class="text-muted"
                ><i class="fas fa-clock mr-1"></i
                >{{ formatDate(message.date) }}</small
              >
            </div>
            <div class="timeline-content">
              <div class="d-flex justify-content-between pt-1">
                <div>
                  <span class="text-muted text-sm font-weight-bold">{{
                   
                  }}</span>
                </div>
              </div>
              <h6 class="text-sm mt-1 mb-0">{{ message.message }}</h6>
            </div>
          </div>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import FormMessages from "../../../components/FormMessages/FormMessages.vue";
import bocapioService from "@/services/nodejs/index";
import swal from "sweetalert2";
import { mapGetters } from "vuex";

export default {
  components: { FormMessages },
  props: {
    messages: { type: Array, default: [] },
    idIssues: { type: Number, default: null },
    userIssues: { type: Object },
    loadingMessages: { type: Boolean, default: false },
  },
  data() {
    return {
      key: "value",
      showForm: false,
      formButtonText: "Enviar",
      formDisableButton: false,
      newMessageButtonText: "Nova mensagem",
    };
  },
  methods: {
    handleClickButtonNewMessage() {
      this.showForm
        ? ((this.newMessageButtonText = "Nova mensagem"),
          (this.showForm = false))
        : ((this.newMessageButtonText = "Fechar"), (this.showForm = true));
    },

    setMessageRead(message) {
      console.log("setReadMessage", message);
    },
    setMessageUnread(message) {
      console.log("setUnreadMessage", message);
    },

    submitForm(payload) {
      console.log("submit from message form", payload);
      this.formButtonText = "Enviando...";
      this.formDisableButton = true;
      bocapioService
        .postMessage(
          payload.message,
          payload.title,
          this.userIssues.id,
          this.idIssues
        )
        .then((rsp) => {
          console.log("resposta postDocumento", rsp.data);
          this.showSwal(
            "Sucesso!!",
            "Mensagem cadastrada com sucesso !!",
            "primary",
            "success"
          );
          this.$refs.formMessage.resetFormMessage();
          this.showForm = false;
          this.addMessageToList(rsp.data);
          this.formButtonText = "Enviar";
          this.newMessageButtonText = "Nova mensagem"
          this.formDisableButton = false;
        })
        .catch((error) => {
          this.formButtonText = "Enviar";
          this.$refs.formMessage.resetFormMessage();
          this.showForm = false;
          this.formButtonText = "Enviar";
          this.newMessageButtonText = "Nova mensagem"
          this.formDisableButton = false;
          this.$router.push("/issues");
          this.showSwal(
            "Erro!!",
            "Algo deu errado. Tente novamente mais tarde !!",
            "warning",
            "warning"
          );
        });
    },

    addMessageToList(message) {
      var currentIsoDate = new Date().toISOString();
      message.date = currentIsoDate;
      this.messages.unshift(message);
    },

    showSwal(title, text, btn, icon) {
      swal.fire({
        title: title,
        text: text,
        buttonsStyling: false,
        confirmButtonClass: `btn btn-${btn}`,
        icon: icon,
      });
    },

    formatDate(date) {
      let d = new Date(date);
      let n = d.toLocaleString();
      return n;
    },
  },
  computed: {
    ...mapGetters([
      "user",
      // ...
    ]),
  },
};
</script>

<style>
.b-card-body {
  max-height: 55vh;
  overflow-y: auto;
}
</style>